// @react/hooks/usePaymentPaymentPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { paymentPaymentPolicyStore } from '@core/stores';

/**
 * React hook for PaymentPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePaymentPaymentPolicy } from '@react/hooks';
 *
 * const PaymentPolicyList = observer(() => {
 *   const store = usePaymentPaymentPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePaymentPaymentPolicy() {
  return paymentPaymentPolicyStore;
}
